import { AfterViewChecked, ChangeDetectorRef, Component, Injector, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { GestaoDeCTEFiltroPesquisaComponent } from "./gestao-de-cte-filtro-pesquisa/gestao-de-cte-filtro-pesquisa.component";
import { GestaoDeCTEGridPesquisaComponent } from "./gestao-de-cte-grid-pesquisa/gestao-de-cte-grid-pesquisa.component";
import { AuthService } from "src/app/services/auth/auth.service";
import { CTEModel, tipoAcao } from "./gestao-de-cte.model";
import { ManutencaoCTEService } from "src/app/services/gestao-de-cte/gestao-de-cte.service";
import { ModalPesoComponent } from "./components/modal-peso/modal-peso.component";
import { HttpErrorResponse } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { GestaoDeCteBaseComponent, Widget } from "./base/gestao-de-cte-base.component";

@Component({
  selector: "app-gestao-de-cte",
  templateUrl:
    "base/gestao-de-cte-base.component.html",
  styleUrls: [
    "base/gestao-de-cte-base.component.scss",
  ],
})
export class GestaoDeCteComponent
  extends GestaoDeCteBaseComponent<CTEModel>
  implements OnInit, AfterViewChecked {
  // public habilitarUploadTemplate: boolean = false;

  // public habilitarAnulacao: boolean = false;
  // public habilitarSubstituicao: boolean = false;
  // public habilitarComplementar: boolean = false;
  // public habilitarCancelamento: boolean = false;
  // public habilitarCartaCorrecao: boolean = false;
  //
  @Input() override featureId: string;
  public componenteFiltro: Widget;
  public componenteGrid: Widget;

  isGridDataUpload: boolean = false;

  public titulo: string = "Gestão de CT-e";
  public subtitulo: string = "Painel de gestão de CT-es em lote com ações";

  public nomeArquivo: string;

  formPesquisa = new FormGroup({
    dtEmissaoIni: new FormControl(""),
    dtEmissaoFim: new FormControl(""),
    nrtCodVolDoc: new FormControl(""),
    clienteId: new FormControl(""),
    produtoId: new FormControl(""),
    tipoCteId: new FormControl(""),
    tipoProcessamentoId: new FormControl(""),
    statusId: new FormControl(""),
    chaveCTE: new FormControl(""),
    numCTE: new FormControl(""),
    filialEmissaoCodigo: new FormControl(""),
    tipoStatusCancelamentoId: new FormControl(""),
  });

  constructor(
    public override injectorObj: Injector,
    public authService: AuthService,
    public override route: ActivatedRoute,
    public cdr: ChangeDetectorRef,
    public router: Router,
    public override service: ManutencaoCTEService,
    public dialog: MatDialog
  ) {
    super(injectorObj, service);

    this.setFilterComponent(GestaoDeCTEFiltroPesquisaComponent);
    this.setGridComponent(GestaoDeCTEGridPesquisaComponent);

    const identificador = this.route.snapshot.paramMap.get('identificador');
    if (identificador) this.iniciarPreLoteAcao(identificador);
  }

  override ngOnInit() {

    // this.authService
    //   .checkFeature(`${this.featureId}.uploadTemplate`)
    //   .subscribe((temPermissao) => {
    //     if (temPermissao === true) this.habilitarUploadTemplate = true;
    //   });
    // this.authService
    //   .checkFeature(`${this.featureId}.anulacao`)
    //   .subscribe((temPermissao) => {
    //     if (temPermissao === true) this.habilitarAnulacao = true;
    //   });
    // this.authService
    //   .checkFeature(`${this.featureId}.substituicao`)
    //   .subscribe((temPermissao) => {
    //     if (temPermissao === true) this.habilitarSubstituicao = true;
    //   });
    // this.authService
    //   .checkFeature(`${this.featureId}.complementar`)
    //   .subscribe((temPermissao) => {
    //     if (temPermissao === true) this.habilitarComplementar = true;
    //   });
    // this.authService
    //   .checkFeature(`${this.featureId}.cancelamento`)
    //   .subscribe((temPermissao) => {
    //     if (temPermissao === true) this.habilitarCancelamento = true;
    //   });
    // this.authService
    //   .checkFeature(`${this.featureId}.cartaodecorrecao`)
    //   .subscribe((temPermissao) => {
    //     if (temPermissao === true) this.habilitarCartaCorrecao = true;
    //   });
  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  iniciarPreLoteAcao(identificador) {
    this.router.navigate(['/cadastro/cte/gestao/pre-lote', identificador]);
  }

  public visualizarPeso(data: CTEModel) {
    this.addTab(
      ModalPesoComponent,
      {
        dados: data,
        isModal: false
      },
      {},
      `edit_${data.id}`,
      `Pesos CTe: ` + data.numCTE
    );
  }

  public acaoEmLote(idAcao: tipoAcao) {
    this.isLoading = false;
  }

  // public acaoUnitaria(idAcao: tipoAcao, data: CTEModel) {
  //   //this.idAcao = idAcao;
  //   this.isLoading = true;
  //   let self = this;
  //   let dados = { data: data, callback: self.gerarAbrir };

  //   this.iniciarAcao(dados, self) //dados e callback
  //   this.isLoading = false;
  // }


  public desabilitaOptAction(id) {
    return false;
    /*
    switch (id) {
      case 1:
        if (this.habilitarAnulacao) {
          return false;
        }
        break;
      case 2:
        if (this.habilitarSubstituicao) {
          return false;
        }
        break;
      case 3:
        if (this.habilitarComplementar) {
          return false;
        }
        break;
      case 4:
        if (this.habilitarCancelamento) {
          return false;
        }
        break;
      case 5:
        if (this.habilitarCartaCorrecao) {
          return false;
        }
        break;
    }
    */
  }


  public getValue(propName) {
    return this.formPesquisa.get(propName)?.value;
  }

  public setValue(propName, value) {
    return this.formPesquisa.get(propName)?.setValue(value);
  }

  public iniciarAcao(tipoAcao, filters) {
    // this.isLoading = true;
    // if (dados?.data?.id) {
    //   this.filters = {
    //     id: dados?.data?.id,
    //     paginaAtual: this.paging.index + 1,
    //     itensPorPagina: this.paging.size,
    //     identificador: this.arquivoFiltro?.identificador
    //   };
    // } else {
    //   this.filters = {
    //     identificador: this.arquivoFiltro?.identificador,
    //     id: null,
    //     dtEmissaoIni: this.getValue("dtEmissaoIni").toISOString().split("T")[0],
    //     dtEmissaoFim: this.getValue("dtEmissaoFim").toISOString().split("T")[0],
    //     nrtCodVolDoc: this.getValue("nrtCodVolDoc"),
    //     clienteId: this.getValue("clienteId"),
    //     tipoCteId: this.getValue("tipoCteId"),
    //     tipoProcessamentoId: this.getValue("tipoProcessamentoId"),
    //     statusId: this.getValue("statusId"),
    //     chaveCTE: this.getValue("chaveCTE"),
    //     numCTE: this.getValue("numCTE"),
    //     filialEmissaoCodigo: this.getValue("filialEmissaoCodigo"),
    //     tipoStatusCancelamento: this.getValue("tipoStatusCancelamento"),
    //     paginaAtual: this.paging.index + 1,
    //     itensPorPagina: this.paging.size,
    //   };
    // }
    // this.service
    //   .gerarGridAcao(tipoAcao, filters)
    //   .subscribe(
    //     (response) => {
    //       if (response.length > 0) {
    //         //this.responseAnulacao = response;
    //         this.openSnackBar(
    //           "Grid gerada com sucesso",
    //           "OK",
    //           3000,
    //           "success-snackbar"
    //         );
    //       }
    //       this.isLoading = false;
    //       dados.callback(dados.data, context);
    //     },
    //     (err: HttpErrorResponse) => {
    //       this.exibirGrid = false;
    //       console.error(err);
    //       this.openSnackBar(
    //         "Ocorreu um erro ao gerar Anulação! Tente novamente",
    //         "OK",
    //         3000,
    //         "danger-snackbar"
    //       );
    //     }
    //   )
    //   .add(() => {
    //     this.isLoading = false;
    //   });
  }

  public filtrarGridPrincipalViaUpload(prelote) {

    this.isLoading = true;
    this.gridData = null;
    this.filters = {
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size,
      identificador: prelote.identificador
    };
    this.service
      .filtrarGridPrincipalViaUpload(prelote.identificador, this.filters)
      .subscribe(
        (response) => {
          this.nomeArquivo = prelote.nomeArquivo;
          this.gridData = response;
          //this.subtitulo = "Os dados exibidos são referentes ao arquivo carregado.";

          if (response.length > 0) {
            this.isGridDataUpload = true;
            this.exibirGrid = true;
            this.paging.length = response[0].totalCount;
          } else {
            this.isGridDataUpload = true;
            this.exibirGrid = false;
            this.deletarArquivoCarregado(prelote.identificador);
            this.openSnackBar(
              "Nenhum registro localizado para o arquivo enviado",
              "OK",
              3000,
              "danger-snackbar"
            );
          }
        },
        (err: HttpErrorResponse) => {
          this.exibirGrid = false;
          console.error(err);
          this.openSnackBar(
            "Ocorreu um erro carregar arquivo! Tente novamente ou entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      )
      .add(() => {
        this.isLoading = false;
      });
  }


  public deletarArquivoCarregado(identificador) {
    this.isLoading = true;
    this.service.deletarPreLote(identificador).subscribe(
      (response: any) => {
        if (response) {
          this.exibirGrid = false;
          this.openSnackBar(
            "Dados excluídos com sucesso",
            "OK",
            3000,
            "success-snackbar"
          );
        }
      },
      (err: HttpErrorResponse) => {
        this.openSnackBar(
          "Ocorreu um erro ao excluir as informações, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
          "OK",
          10000,
          "danger-snackbar"
        );
        console.error("erro", err)
      }
    ).add(() => {
      this.isLoading = false;
    });
  }
}
